<template>
    <div class="position-relative" ref="dropdown" @click.stop="openDropdown">
        <div>
            <DropdownInputHeader
                class="w-100 tf-border-rounded--md"
                :placeholder="store.contents.placeHolders.stations"
                :label="label"
                :events="controls.header"
                :has-value="!!selected"
                @input="(e) => controls.tabsAutocomlete.fire('filter', e)"
                @clear="clear"
                :dataId="'stations-input'"
                @keyup="onKeyUp"
            >
                <span slot="icon-left">
                    <GeoIcon />
                </span>
                <span slot="icon-right">
                    <ArrowUp v-show="!state.isOpen" />
                    <ArrowDown v-show="state.isOpen" />
                </span>
            </DropdownInputHeader>
        </div>
        <div
            class="dropdown-menu stations-dropdown min-w-100 p-0 overflow-hidden"
            :class="{
                show: state.isOpen
            }"
            style="min-width: 300px"
            @click.stop
        >
            <TabsAutocomplete
                :tabs="stationTabs"
                :events="controls.tabsAutocomlete"
                :selected="selected"
                :is-selected="isSelected"
                @select="select"
            ></TabsAutocomplete>
        </div>
    </div>
</template>

<script>
import Events from 'tf-events-1'
import { onClickOutside } from '@vueuse/core'

// components
import DropdownInputHeader from '@se/components/dropdown-input-header.vue'
import TabsAutocomplete from '@se/components/tabs-autocomplete.vue'
import ArrowUp from '@se/components/svg/common/arrow-up/index.vue'
import ArrowDown from '@se/components/svg/common/arrow-down/index.vue'
import GeoIcon from '@se/components/svg/common/geo/index.vue'

// bl
import getStationsTabsAutocomplete from '@se/bl/tabs-autocomplete/stations'

import { emitStationsValue, emitParentStationsValue } from '../../logic/globalizeValues'

export default {
    name: 'StationsTabsAutocomplete',
    components: {
        // components
        DropdownInputHeader,
        TabsAutocomplete,
        ArrowUp,
        ArrowDown,
        GeoIcon
    },
    props: {
        store: Object
    },
    data() {
        return {
            controls: {
                header: Events(),
                tabsAutocomlete: Events()
            },
            data: {},
            off: {
                list: [],
                onClose: null
            },
            state: {
                isOpen: false
            }
        }
    },
    computed: {
        se() {
            return this.store.libs.se
        },
        stationTabs() {
            if (!this.store.data.geoData || !this.store.data.available) {
                return []
            }
            const stations = this.store.data.geoData.stations.filter((station) => {
                return this.store.data.available.stationsMap[station.id]
            })
            const stationTabs = getStationsTabsAutocomplete({
                stations,
                parentStations: this.store.data.geoData.parentStations,
                countries: this.store.data.geoData.countries
            })
            return stationTabs
        },
        label() {
            const selected = this.store.data.selected
            if (selected.stations && selected.stations.length > 0) {
                const stationId = this.store.data.selected.stations?.[0]
                return this.store.data.geoData.stationsMap[stationId]?.label
            }
            if (selected.parentStations && selected.parentStations.length > 0) {
                const parentStationId = this.store.data.selected.parentStations?.[0]
                return this.store.data.geoData.parentStationsMap[parentStationId]?.label
            }
        },
        selected() {
            const selected = this.store.data.selected
            return selected.stations && selected.stations.length > 0
                ? selected.stations
                : selected.parentStations && selected.parentStations.length > 0
                ? selected.parentStations
                : null
        }
    },
    methods: {
        isSelected({ id, isStation, isParentStation }) {
            if (isStation) {
                return this.store.data.selected.stations?.[0] === id
            }
            if (isParentStation) {
                return this.store.data.selected.parentStations?.[0] === id
            }
        },
        onKeyUp(e) {
            if (e.key === 'ArrowUp') {
                this.controls.tabsAutocomlete.fire('up')
            }
            if (e.key === 'ArrowDown') {
                this.controls.tabsAutocomlete.fire('down')
            }
            if (e.key === 'ArrowLeft') {
                this.controls.tabsAutocomlete.fire('left')
            }
            if (e.key === 'ArrowRight') {
                this.controls.tabsAutocomlete.fire('right')
            }
            if (e.key === 'Enter') {
                this.controls.tabsAutocomlete.fire('select')
            }
        },
        select({ id, isStation, isParentStation }) {
            this.se.batch(() => {
                if (isStation) {
                    this.se.setFieldValue('station', [id])
                    this.se.setFieldValue('parentStation', undefined)
                    emitStationsValue([id])
                    emitParentStationsValue(undefined)
                }
                if (isParentStation) {
                    this.se.setFieldValue('station', undefined)
                    this.se.setFieldValue('parentStation', [id])
                    emitStationsValue(undefined)
                    emitParentStationsValue([id])
                }
            })
            this.controls.header.fire('blur')
            this.onClose()
        },
        clear() {
            this.state.filter = ''
            this.se.batch(() => {
                this.se.setFieldValue('station', undefined)
                this.se.setFieldValue('parentStation', undefined)
                emitStationsValue(undefined)
                emitParentStationsValue(undefined)
            })
        },
        onOpen() {
            this.state.isOpen = true
            this.$nextTick(() => {
                this.controls.tabsAutocomlete.fire('reset-scroll')
            })
        },
        onClose() {
            this.off.onClose?.()
            this.state.isOpen = false
            this.controls.header.fire('filter', '')
            this.controls.tabsAutocomlete.fire('filter', '')
            this.controls.tabsAutocomlete.fire('reset-selected')
        },
        openDropdown(e) {
            e.stopPropagation()
            this.state.isOpen = !this.state.isOpen
            this.$emit('openStations', e)
            if (!this.state.isOpen) {
                this.onClose()
            }
        }
    },
    beforeDestroy() {
        this.off.list.forEach((off) => off())
    },
    mounted() {
        $('#domain-button').on('click', (e) => {
            this.onClose()
        })
        $('body').on('click', (e) => {
            this.state.isOpen = false
            this.onClose()
        })

        onClickOutside(this.$refs.dropdown, () => {
            this.onClose()
        })
    }
}
</script>

<style></style>
